import Item from './Item.js';
import { imageStore } from '../images.js';
import Sprite from '../ui/Sprite.js';

export default class Pokeball extends Item {
    constructor({ id, name, description, catchRate = 0, price }) {
        super({ id, name, description, price });
        this.catchRate = catchRate;
        this.overworldOptions = ['Use', 'Give', 'Cancel'];
        let thrownImage = null;
        let openImage = null;
        let closeImage = null;
        let backImage = null;
        switch (id) {
            case 'pokeball':
                thrownImage = imageStore.get('img/pokeball_opening.png');
                openImage = imageStore.get('img/pokeball_opening.png');
                closeImage = imageStore.get('img/pokeball_closing.png');
                backImage = imageStore.get('img/player_back_pokeball.png');
                break;
            case 'great_ball':
                thrownImage = imageStore.get('img/great_ball_opening.png');
                openImage = imageStore.get('img/great_ball_opening.png');
                closeImage = imageStore.get('img/great_ball_closing.png');
                backImage = imageStore.get('img/player_back_great_ball.png');
                break;
            case 'ultra_ball':
                thrownImage = imageStore.get('img/ultra_ball_opening.png');
                openImage = imageStore.get('img/ultra_ball_opening.png');
                closeImage = imageStore.get('img/ultra_ball_closing.png');
                backImage = imageStore.get('img/player_back_ultra_ball.png');
                break;
            case 'master_ball':
                thrownImage = imageStore.get('img/master_ball_opening.png');
                openImage = imageStore.get('img/master_ball_opening.png');
                closeImage = imageStore.get('img/master_ball_closing.png');
                backImage = imageStore.get('img/player_back_master_ball.png');
                break;
            default:
                throw new Error(`Invalid pokeball id: ${id}`);
        }
        this.battleSprites = {
            thrown: new Sprite({
                image: thrownImage,
                position: { x: 0, y: 0 },
                moving: false,
                visible: false,
                frames: { val: 0, max: 3, stopAtEnd: false },
                hold: 4,
                yVelocity: 0,
                gravity: 0,
                origin: {
                    x: 0.5,
                    y: 0.625,
                },
            }),
            open: new Sprite({
                image: openImage,
                position: { x: 0, y: 0 },
                moving: false,
                visible: false,
                frames: { val: 0, max: 3, stopAtEnd: true },
                hold: 4,
                yVelocity: 0,
                gravity: 0,
                origin: {
                    x: 0.5,
                    y: 0.625,
                },
            }),
            close: new Sprite({
                image: closeImage,
                position: { x: 0, y: 0 },
                moving: false,
                visible: false,
                frames: { val: 0, max: 3, stopAtEnd: true },
                hold: 4,
                yVelocity: 0,
                gravity: 0,
                origin: {
                    x: 0.5,
                    y: 0.625,
                },
            }),
            back: new Sprite({
                position: { x: 0, y: 0 },
                image: backImage,
                frames: { val: 0, max: 5 },
                moving: false,
            }),
        };
    }
}
